import { useEffect, useState } from 'react';
import { useApp } from '../../../contexts';
import api from '../../../services/api';
import { Text, TableContainer, Table, TableHead, TableCell, TableBody, TableRow } from '../index'
import DeleteIcon from '@mui/icons-material/Delete';

export default function AnonymizedEmailsList({ accessToken }) {

  const { setLoading, showDialog, closeDialog } = useApp();
  const [emailList, setEmailList] = useState([])

  useEffect(() => {
    getBlackList();
  }, [])

  const getBlackList = async () => {
    setLoading(true)
    const config = {}
    if(accessToken !== ""){
        config.headers = {
            'Authorization': 'Bearer ' + accessToken,
            "Content-Type": "application/json"
        }
    }
    await api.post(`/lgpd/blackList`, {}, config).then((response) => {
      setEmailList(response.data.emails);
      setLoading(false);
    }).catch(err => {
        setLoading(false);
        closeDialog();
        showDialog({
          title: `Atenção`,
          component: <>{err.response.data.msg}</>
         })
    });
  }

  const deleteBlackList = async (id) => {
      setLoading(true)
      const config = {}
      if(accessToken !== ""){
          config.headers = {
              'Authorization': 'Bearer ' + accessToken,
              "Content-Type": "application/json"
          }
      }
      await api.delete(`/lgpd/blackList/delete/${id}`, { ...config } ).then(() => {
        setLoading(false);
        getBlackList();
      }).catch(() => {
        setLoading(false);
      });
  }

  return (
    <TableContainer>
        <Table size="small">
            <TableHead>
                <TableRow>
                    <TableCell>
                        <Text style={{ fontWeight: '700' }}>E-mail</Text>
                    </TableCell>
                    <TableCell>
                        <Text style={{ fontWeight: '700' }}>Ações</Text>
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                { emailList.length > 0 && emailList.map((item, index) => {
                    return (
                        <TableRow key="{`row-email-list-${index}`}">
                            <TableCell>{item.email}</TableCell>
                            <TableCell onClick={() => deleteBlackList(item.id)}><DeleteIcon sx={{ cursor: "pointer" }} /></TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
        </Table>
    </TableContainer>
  )
}